import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { FC, PropsWithChildren } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/status',
    }),
  }
}

// incident body
const PBody: FC<PropsWithChildren> = ({ children }) => (
  <div className='text-gray-800 dark:text-gray-200'>{children}</div>
)

function Status() {
  const { t } = useTranslation('status')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <div className='space-y-3'>
          <div>
            <Header className='capitalize'>{t('header')}</Header>
            <p className='text-base pb-5'>{t('header-subtitle')}</p>
          </div>
          <div>
            <h2 className='text-xl font-bold'>{t('sub-header')}</h2>
            <div className='py-1'>
              <p className='text-base'>{t('no-issues')}</p>
            </div>
          </div>
          <div className='pb-4'>
            <h3 className='text-lg font-semibold'>{t('prev-incidents')}</h3>
            <div className='py-2 space-y-2'>
              <p className='text-base text-gray-900 dark:text-gray-100'>
                {t('incidents.0.date')}
              </p>
              <PBody>{t('incidents.0.body')}</PBody>
            </div>
          </div>
        </div>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Status },
  {
    translation: 'status',
  }
)
